// @flow

export const SET_LOOM_STATUS = 'SET_LOOM_STATUS'
export const ADD_EDITOR_RECOVERY_DATA = 'ADD_EDITOR_RECOVERY_DATA'
export const CLEAR_EDITOR_RECOVERY_DATA = 'CLEAR_EDITOR_RECOVERY_DATA'
export const INSERT_LOOM = 'INSERT_LOOM'
export const LOOM_INSERTION_COMPLETE = 'LOOM_INSERTION_COMPLETE'

export function setLoomStatus(sessionId: string, active: boolean): Object {
  return {
    type: SET_LOOM_STATUS,
    sessionId: sessionId,
    active: active
  }
}

export function addEditorRecoveryData(sessionId: string, content: string, selection: number): Object {
  return {
    type: ADD_EDITOR_RECOVERY_DATA,
    sessionId: sessionId,
    recovery: {
      content: content,
      selection: selection
    }
  }
}

export function clearEditorRecoveryData(): Object {
  return {
    type: CLEAR_EDITOR_RECOVERY_DATA
  }
}

export function insertLoom(sessionId: string, videoData: Object): Object {
  return {
    type: INSERT_LOOM,
    sessionId: sessionId,
    videoData: videoData
  }
}

export function loomInsertionComplete(): Object {
  return {
    type: LOOM_INSERTION_COMPLETE
  }
}
